// Supporta $in, $ne e match esatto
function matchCondition(obj, cond = {}) {
    return Object.entries(cond || {}).every(([k, rule]) => {
        const v = obj ? obj[k] : undefined;
        if (rule && typeof rule === 'object' && !Array.isArray(rule)) {
            if (Array.isArray(rule.$in)) return rule.$in.includes(v);
            if (Object.prototype.hasOwnProperty.call(rule, '$ne')) return v !== rule.$ne;
            // fallback: tutti i campi dell'oggetto devono matchare
            return Object.entries(rule).every(([kk, vv]) => (obj?.[k]?.[kk] === vv));
        }
        return v === rule;
    });
}

export function evaluate(policies, ctx) {
    // ctx: { action, resource, attrs }
    const ordered = (policies || []).slice().sort((a, b) => a.priority - b.priority);
    for (const p of ordered) {
        if (p.action === ctx.action && p.resource === ctx.resource) {
            if (!p.condition || matchCondition(ctx.attrs, p.condition)) {
                return p.effect === 'allow';
            }
        }
    }
    return false; // default deny
}
